const mistakes = [
  {
    icon: "ri-time-line",
    title: "Waiting Until the Last Minute",
    desc: "Many Rapid City travelers apply too late. Routine processing takes 6–11 weeks. Even expedited can take 3–5 weeks via post office. Start at least 3 months before travel.",
  },
  {
    icon: "ri-camera-line",
    title: "Incorrect Passport Photo",
    desc: "Photos must meet strict State Department requirements. White background, no glasses, specific dimensions. A rejected photo adds weeks to your application.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Submitting an Incomplete DS-11 or DS-82",
    desc: "Missing fields, wrong dates, or incorrect fees are the most common causes of rejection. Our agents review every form before submission to catch these errors.",
  },
  {
    icon: "ri-bank-line",
    title: "Making the Check Out Wrong",
    desc: "Government fees must be paid by a separate check or money order made out to U.S. Department of State — not the post office or any other entity.",
  },
  {
    icon: "ri-map-2-line",
    title: "Driving to Denver When It Isn\u2019t Necessary",
    desc: "Regional agencies only handle true emergencies. Most Rapid City applicants don\u2019t qualify for walk-in service. A courier handles the same expedited result without the 360-mile drive.",
  },
  {
    icon: "ri-parent-line",
    title: "Forgetting Both Parents for Child Applications",
    desc: "Children under 16 require in-person appearance by both parents. If one parent cannot attend, a DS-3053 notarized consent form is required. Missing this causes immediate rejection.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Passport Mistakes Rapid City Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These errors cost travelers weeks of delay — or missed trips entirely. Our agents are trained to catch every one of these before your application is submitted.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200 hover:border-red-200 transition-all duration-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-4">
                <i className={`${m.icon} text-red-500 text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/80 text-sm max-w-xl">
            Fast Passport Center&apos;s dedicated agents review your entire application before submission — catching these mistakes before they cause delays.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Protect My Application <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}